"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var View = function View(_ref) {
  var _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$fullHeight = _ref.fullHeight,
      fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["fullWidth", "fullHeight", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex justify-center items-center', {
      'w-full': fullWidth,
      'h-full': fullHeight
    }, className)
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], props));
};

View.displaytitle = 'CircularLoader';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=index.js.map